export class MedicationCount {
   
    fromDate: Date;
    toDate: Date;
    pharmacyProductId?: number;
    medicineCount?: number;
    productName?: string;
    rankNumber?: number;
   
}